import axios from 'axios'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { EntityIdentifiersRequest, EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'
import {
    CustomerTypeCreateRequest, CustomerTypePatchInBatchRequest, CustomerTypeResponse
} from '@/modules/configurationModule/detail/accounting/billable/customer-types/services/customer-types.dto'

class CustomerTypesService {
    async create(request: CustomerTypeCreateRequest): Promise<CustomerTypeResponse> {
        const response = await axios.post<CustomerTypeResponse>(`/configuration/customerTypes`, request)
        return response.data
    }

    async paginator(filterModel: CommonFilterModel | undefined, params: CommonParams | undefined): Promise<IResponseAgGrid<CustomerTypeResponse>> {
        const response = await axios.put<IResponseAgGrid<CustomerTypeResponse>>(`/configuration/customerTypes`, { ...filterModel }, { params })
        return response.data
    }

    async get(clientTypeId: number): Promise<CustomerTypeResponse> {
        const response = await axios.get<CustomerTypeResponse>(`/configuration/customerTypes/${clientTypeId}`)
        return response.data
    }

    async delete(request: EntityIdentifiersRequest): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.delete<EntityIdentifierWithErrorResponse[]>(`/configuration/customerTypes/batch`, { data: request })
        return response.data
    }

    async patch(request: CustomerTypePatchInBatchRequest[]): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.patch<EntityIdentifierWithErrorResponse[]>(`/configuration/customerTypes/batch`, request)
        return response.data
    }
}

export const customerTypesService = new CustomerTypesService()
